import HeadwayWidget from './HeadwayWidget';

export default HeadwayWidget;
